import { Component } from 'preact'

export default class Focusable extends Component {

  handleOnClick = event => {
    if (this.props.onClick !== undefined) {
      event.preventDefault()
      event.stopPropagation()
      if (typeof this.props.onClick === 'function') {
        this.props.onClick(event)
      }
    } else if (this.props.onEnter !== undefined) {
      event.preventDefault()
      event.stopPropagation()
      if (typeof this.props.onEnter === 'function') {
        this.props.onEnter(event)
      }
    }
  }

  handleKeyDown = event => {

    if (this.context.resetPlayerCountdown !== undefined) {
      this.context.resetPlayerCountdown()
    }

    // console.log(`Focusable::handleKeyDown -> ${event.key} -> 0x${event.keyCode.toString(16)} = ${event.keyCode}`)

    if (event.key === 'Enter' || event.keyCode === 0x0D) {
      this.processKeyDown(event, this.props.onEnter, this.props.onClick)
    } else if (event.key === 'Space' || event.keyCode === 0x20) {
      this.processKeyDown(event, this.props.onSpace)
    } else if (event.key === 'ArrowUp' || event.key === 'Up' || event.keyCode === 0x26) {
      this.processKeyDown(event, this.props.onArrowUp)
    } else if (event.key === 'ArrowDown' || event.key === 'Down' || event.keyCode === 0x28) {
      this.processKeyDown(event, this.props.onArrowDown)
    } else if (event.key === 'ArrowLeft' || event.key === 'Left' || event.keyCode === 0x25) {
      this.processKeyDown(event, this.props.onArrowLeft)
    } else if (event.key === 'ArrowRight' || event.key === 'Right' ||event.keyCode === 0x27) {
      this.processKeyDown(event, this.props.onArrowRight)
    } else if (event.key === 'ChannelUp' || event.keyCode === 0x1ab
      || event.key === 'PageUp' || event.keyCode === 0x21) {
      this.processKeyDown(event, this.props.onChannelUp, this.props.onArrowUp)
    } else if (event.key === 'ChannelDown' || event.keyCode === 0x1ac
      || event.key === 'PageDown' || event.keyCode === 0x22) {
      this.processKeyDown(event, this.props.onChannelDown, this.props.onArrowDown)
    } else if (event.key === 'Tab' || event.keyCode === 0x09) {
      this.processKeyDown(event, this.props.onTab)
    } else if (event.key === 'Backspace' || event.keyCode === 0x8
      || event.key === 'Escape' || event.keyCode === 0x1b
      || event.key === 'RCUBack' || event.key === 'XF86Back'
      || event.keyCode === 0x1ce /* Menu key on the MediaTek remote controls */
      || event.keyCode === 0x1cd /* Back key on the LG WebOS 3.x devices */) {
      this.processKeyDown(event, this.props.onBack)
    } else if (event.key === 'ColorF0Red' || event.keyCode === 0x193) {
      this.processKeyDown(event, this.props.onColorRed)
    } else if (event.key === 'ColorF1Green' || event.keyCode === 0x194) {
      this.processKeyDown(event, this.props.onColorGreen)
    } else if (event.key === 'ColorF2Yellow' || event.keyCode === 0x195) {
      this.processKeyDown(event, this.props.onColorYellow)
    } else if (event.key === 'ColorF3Blue' || event.keyCode === 0x196) {
      this.processKeyDown(event, this.props.onColorBlue)
    } else if (event.key === 'MediaPlay' || event.keyCode === 0x19f) {
      this.processKeyDown(event, this.props.onMediaPlay)
    } else if (event.key === 'Pause' || event.keyCode === 0x13) {
      this.processKeyDown(event, this.props.onPause)
    } else if (event.key === 'MediaStop' || event.keyCode === 0x19d) {
      this.processKeyDown(event, this.props.onMediaStop)
    } else if (event.key === 'MediaFastForward' || event.key === ']' || event.keyCode === 0x1a1) {
      this.processKeyDown(event, this.props.onMediaFastForward)
    } else if (event.key === 'MediaRewind' || event.key === '[' || event.keyCode === 0x19c) {
      this.processKeyDown(event, this.props.onMediaRewind)
    } else if (event.keyCode === 0x3ec // EPG button on MediaTek
      || event.keyCode === 0x3fc) { // Guide button on MediaTek
      this.processKeyDown(event, this.props.onGuide)
    } else if (event.key === '0' || event.keyCode === 0x30) {
      this.processKeyDown(event, this.props.onDigit0)
    } else if (event.key === '1' || event.keyCode === 0x31) {
      this.processKeyDown(event, this.props.onDigit1)
    } else if (event.key === '2' || event.keyCode === 0x32) {
      this.processKeyDown(event, this.props.onDigit2)
    } else if (event.key === '3' || event.keyCode === 0x33) {
      this.processKeyDown(event, this.props.onDigit3)
    } else if (event.key === '4' || event.keyCode === 0x34) {
      this.processKeyDown(event, this.props.onDigit4)
    } else if (event.key === '5' || event.keyCode === 0x35) {
      this.processKeyDown(event, this.props.onDigit5)
    } else if (event.key === '6' || event.keyCode === 0x36) {
      this.processKeyDown(event, this.props.onDigit6)
    } else if (event.key === '7' || event.keyCode === 0x37) {
      this.processKeyDown(event, this.props.onDigit7)
    } else if (event.key === '8' || event.keyCode === 0x38) {
      this.processKeyDown(event, this.props.onDigit8)
    } else if (event.key === '9' || event.keyCode === 0x39) {
      this.processKeyDown(event, this.props.onDigit9)
    } else {
      if (typeof this.props.onKeyDown === 'function') {
        this.props.onKeyDown(event)
      }
    }
  }

  processKeyDown = (...args) => {
    const event = args[0]
    const callbacks = args.slice(1, args.length)
    const processed = callbacks.some(callback => {
      if (callback !== undefined) {
        event.preventDefault()
        event.stopPropagation()
        if (typeof callback === 'function') {
          callback(event)
        }
        return true
      }
      return false
    })

    if (!processed && typeof this.props.onKeyDown === 'function') {
      this.props.onKeyDown(event)
    }
  }

  handleFocus = () => {
    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus()
    }
  }

  handleBlur = _ => {
    if (this.context.getFocusedElement !== undefined) {
      const focusedElement = this.context.getFocusedElement()
      if (focusedElement === this.el) {
        setTimeout(_ => {
          this.el.focus()
        }, 0)
      }
    }
  }

  render({
    children, isFocused,
    onClick, onKeyDown, onEnter, onBack,
    onArrowUp, onArrowDown, onArrowLeft, onArrowRight,
    onChannelUp, onChannelDown,
    ...restProps
  }) {

    return (
      <div
        tabIndex="-1"
        ref={el => {
          if (el) {
            // console.log('focused on ', el)
            this.el = el
            if (isFocused) {
              setTimeout(() => {
                if (this.context.setFocusedElement !== undefined) {
                  this.context.setFocusedElement(el)
                }
                el.focus()
              }, 0)
            }
          }
        }}
        onClick={this.handleOnClick}
        onKeyDown={this.handleKeyDown}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        {...restProps}>
        {children}
      </div>
    )
  }
}
